import styled from 'styled-components';
import { DropdownWrapper } from 'Screens/Contextualization/Manage/components/CreateActions/styled';
import { ReactComponent as PlusIcon } from 'Images/icon-action-bar-plus.svg';

export const Button = styled(DropdownWrapper)`
    width: 139px;
    justify-content: left;
    gap: 5px;
`;

export const Plus = styled(PlusIcon)`
  height: 11px;
  margin-bottom: 2px;
  & > path {
    fill: ${({ theme }) => theme.buttons.custom.color};
  }
`;
